module.exports = __webpack_public_path__ + "img/message-circle-grey.8aee7d75.svg";